<dl-sidebar-button (click)="toggleSidebar()">
  <ng-content></ng-content>
</dl-sidebar-button>